import React from "react";
import ExperienceCard from "../../components/experienceCard/index";
import type { ExperienceSection } from "types";

interface ExperienceAccordionProps {
  sections: ExperienceSection[];
}

function ExperienceAccordion({
  sections,
}: ExperienceAccordionProps): React.ReactElement {
  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 mt-16 space-y-16">
      {sections.map((section) => (
        <div key={section.title} className="space-y-8">
          {/* Section header */}
          <div className="flex items-center gap-4 pb-4 border-b border-border">
            <div className="flex items-center justify-center w-10 h-10 text-lg bg-accent/10 border border-accent/20 rounded text-accent">
              💼
            </div>
            <div>
              <h2 className="text-xl md:text-2xl font-display font-bold tracking-tight text-text-primary">
                {section.title}
              </h2>
              <p className="text-xs font-mono text-text-muted mt-0.5">
                {section.experiences.length} position
                {section.experiences.length > 1 ? "s" : ""}
              </p>
            </div>
          </div>

          {/* Timeline */}
          <div className="relative">
            {/* Vertical line */}
            <div className="absolute left-5 md:left-6 top-0 bottom-0 w-px bg-gradient-to-b from-accent/40 via-accent/20 to-transparent hidden md:block" />

            <div className="space-y-6">
              {section.experiences.map((experience, index) => (
                <div key={experience.title + index} className="relative">
                  {/* Timeline dot */}
                  <div className="absolute z-10 hidden md:block left-4 md:left-5 top-8 w-2.5 h-2.5 rounded-full border-2 border-accent bg-bg-primary" />
                  <div className="md:ml-12">
                    <ExperienceCard experience={experience} />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

export default ExperienceAccordion;
